export type BoardConfigurationData = {
  board: {
    displayMode: BoardDisplayMode;
  };
  padding: {
    left: number;
    top: number;
  };
  margin: {
    left: number;
    leftText: number;
    leftInsideBoard: number;
    rightInsideBoard: number;
  };
  ringBoardWidth: number;
  segment: {
    width: number;
    height: number;
    keyLabel: string;
    tilt: {
      value: number;
      extendedValue: number;
    };
  };
};

export type RingInterval = {
  start: number;
  end: number;
};

export type RingData = {
  id: string;
  label?: string;
  type: string;
  marginX: number;
  compliantDate: string | null;
  segments: SegmentData[];
  hasKeyPosition: boolean;
};

export type SegmentData = {
  id: string | null;
  key: string;
  label: string;
  shapeType: SegmentShapeType;
  defects: DefectReport[];
};

export type DefectReport = {
  id: string;
  strokes: Point[];
  color: string;
  toRepair: boolean;
  submittedAt: string | null;
  repairSubmittedAt: string | null | undefined;
};

export type Point = {
  x: number;
  y: number;
};

export enum SegmentShapeType {
  Key = 'KEY',
  KeyInverted = 'INVERT_KEY',
  HalfKey = 'HALF_KEY',
  TiltedLeft = 'TILT_LEFT',
  TiltedLeftExtended = 'TILT_LEFT_EXTENDED',
  TiltedRight = 'TILT_RIGHT',
  TiltedRightExtended = 'TILT_RIGHT_EXTENDED',
}

export enum BoardDisplayMode {
  Preview,
  Complete,
  Ring,
}
